// removed by extract-text-webpack-plugin
module.exports = {"mask":"src-node_modules-kts-platform-frame-display-part-RightPopUps-index__mask--1POrm","container":"src-node_modules-kts-platform-frame-display-part-RightPopUps-index__container--qyDZv","title":"src-node_modules-kts-platform-frame-display-part-RightPopUps-index__title--30tpv","cha1":"src-node_modules-kts-platform-frame-display-part-RightPopUps-index__cha1--5Tx17","body":"src-node_modules-kts-platform-frame-display-part-RightPopUps-index__body--3iaQ6"};


//////////////////
// WEBPACK FOOTER
// ./src/node_modules/kts-platform-frame/display/part/RightPopUps/index.scss
// module id = 565
// module chunks = 0